import FocusableNodeType, {TFocusableNodeType} from '../Constants/FocusableNodeType';

const supportedContainerTypesForHorizontalParent: TFocusableNodeType[] = [
    FocusableNodeType.VERTICAL_LIST,
    FocusableNodeType.VIRTUAL_VERTICAL_LIST,
];

// NB: As a grid can only be constrained horizontally (with dynamic height)
// justification is only supported for grids within a vertical parent.

const supportedContainerTypesForVerticalParent: TFocusableNodeType[] = [
    FocusableNodeType.HORIZONTAL_LIST,
    FocusableNodeType.VIRTUAL_HORIZONTAL_LIST,
    FocusableNodeType.GRID,
];

const isJustificationSupported = (
    parentContainerType: TFocusableNodeType,
    childContainerType: TFocusableNodeType
): boolean => {
    const allowedTypes: TFocusableNodeType[] = {
        [FocusableNodeType.HORIZONTAL_LIST]: supportedContainerTypesForHorizontalParent,
        [FocusableNodeType.VIRTUAL_HORIZONTAL_LIST]: supportedContainerTypesForHorizontalParent,
        [FocusableNodeType.VERTICAL_LIST]: supportedContainerTypesForVerticalParent,
        [FocusableNodeType.VIRTUAL_VERTICAL_LIST]: supportedContainerTypesForVerticalParent,
        [FocusableNodeType.LEAF]: [],
        [FocusableNodeType.GRID]: [],
    }[parentContainerType];

    return allowedTypes.indexOf(childContainerType) > -1;
};

export default isJustificationSupported;
